export default function authHeader() {
  const obj = localStorage.getItem("accessToken")
    ? localStorage.getItem("accessToken")
    : "";

  if (obj) {
    return `Bearer ${obj}`;
  } else {
    return "";
  }
}
